import React from 'react';

import './Modal.scss';

const Modal = (props) => {
    if (props.show) {
        return (
            <div className="modal-container">
                <div className="overlay" />
                <div className="modal-window">
                    <props.component />
                </div>
            </div>
        );
    }
    return null;
};

export default Modal;



// WEBPACK FOOTER //
// ./src/components/Modal/Modal.js